// Module
var code = "<nlg-panel> <nlg-panel-title> <span translate>microstrategy.title</span> </nlg-panel-title> <div> <nlg-microstrategy-configuration></nlg-microstrategy-configuration> </div> </nlg-panel>";
// Exports
module.exports = code;